module.exports = __webpack_public_path__ + "img/dpj.6b77e9c9.jpg";